<template>
  <div :class="[ns.b, ns.direction]">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { computed, getCurrentInstance, provide, watch } from 'vue'
import { useNamespace, useOrderedChildren } from '@xzx-design/hooks'
import { CHANGE_EVENT } from '@xzx-design/constants'
import { stepsEmits, stepsProps } from './steps'

import type { StepItemState } from './step.vue'
import type { ComponentInternalInstance } from 'vue'

defineOptions({
  name: 'XzxSteps',
})

const props = defineProps(stepsProps)
const emit = defineEmits(stepsEmits)

const {
  children: steps,
  addChild: addStep,
  removeChild: removeStep,
} = useOrderedChildren<StepItemState>(
  getCurrentInstance() as ComponentInternalInstance,
  'XzxStep'
)

provide('XzxSteps', { props, steps, addStep, removeStep })

const direcType = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  [props.direction]: props.direction,
}

const ns = computed(() => ({
  b: useNamespace('steps').b(),
  direction: direcType?.[props.direction]
    ? useNamespace('steps').is(props.direction)
    : useNamespace('steps').is('horizontal'),
}))

watch(steps, () => {
  steps.value.forEach((instance: any, index: number) => {
    instance.setIndex(index)
  })
})

watch(
  () => props.active,
  (newVal: number, oldVal: number) => {
    emit(CHANGE_EVENT, newVal, oldVal)
  }
)
</script>
